// src/utils/gtm.js
/**
 * Utilidad para cargar Google Tag Manager dinámicamente según el ambiente
 */
import { APP_CONFIG } from '../config/environment.js';

/**
 * Inicializa Google Tag Manager si está habilitado para el ambiente actual
 */
export const initializeGTM = () => {
  const gtmId = APP_CONFIG.GTM.ID;
  const isEnabled = APP_CONFIG.GTM.ENABLED;
  const environment = APP_CONFIG.ENV;

  // Log en desarrollo/QA
  if (APP_CONFIG.IS_DEVELOPMENT || APP_CONFIG.IS_QA) {
    console.log(`🏷️ GTM Configuration [${environment.toUpperCase()}]:`, {
      gtmId: gtmId || 'Not configured',
      enabled: isEnabled,
      environment: environment
    });
  }

  // No cargar GTM si no está habilitado o no hay ID
  if (!isEnabled || !gtmId) {
    if (APP_CONFIG.IS_DEVELOPMENT || APP_CONFIG.IS_QA) {
      console.warn('⚠️ GTM is disabled for this environment');
    }
    return;
  }

  // Cargar GTM script
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', gtmId);

  // Cargar noscript iframe
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

  console.log(`✅ GTM loaded: ${gtmId}`);
};

/**
 * Envía un evento personalizado a GTM
 * @param {string} eventName - Nombre del evento
 * @param {object} eventData - Datos adicionales del evento
 */
export const sendGTMEvent = (eventName, eventData = {}) => {
  if (!APP_CONFIG.GTM.ENABLED || !window.dataLayer) {
    if (APP_CONFIG.IS_DEVELOPMENT) {
      console.log('📊 GTM Event (not sent - GTM disabled):', eventName, eventData);
    }
    return;
  }

  window.dataLayer.push({
    event: eventName,
    ...eventData
  });

  if (APP_CONFIG.IS_DEVELOPMENT || APP_CONFIG.IS_QA) {
    console.log('📊 GTM Event sent:', eventName, eventData);
  }
};

export default {
  initializeGTM,
  sendGTMEvent
};
